const skills = [
  {
    title: "Web Development",
    content:
      "CSS | styled-components | JavaScript | PHP | ReactJS | Tailwind | Node.js | ExpressJS | Django | FastApi | Flask | MongoDB | MySQL | PostGreSQL | REST | GraphQL ",
    icon: "fas fa-code",
  },
  {
    title: "Machine Learning",
    content:
      "Python | Pandas | NumPy | Scikit-Learn | Matplotlib | Seaborn | Tensorflow | Keras | Pytorch | OpenCV | BeautifulSoup",
    icon: "fas fa-robot",
  },
  {
    title: "DevOps",
    content:
      "GoLang | Docker | Kubernetes | AWS | GCP | Azure | Jenkins | Git | Github | Gitlab | Terraform | Grafana | Bash | Linux ",
    icon: "fas fa-infinity",
  },
];

export default skills;
